export default __webpack_public_path__ + "static/media/download.b891614f.svg";